import React from 'react';
import GridLayout from '../../GridLayout';
import './style.css';

export default ({children}) => (
    <nav className="MenuSection">
        <GridLayout className="content">{children}</GridLayout>
    </nav>
);



// WEBPACK FOOTER //
// ./src/common/sections/MenuSection/index.js